import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'kion-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit{

  @Input() controlName: string;
  @Input() placeHolder: string;
  @Input() label: string;
  @Input() id: string;
  @Input() invalid: boolean;
  @Input() form: FormGroup;

  // tslint:disable-next-line:no-output-rename
  @Output('init') initEmitter: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit(): void {
    this.initEmitter.emit();
  }
}
